import { useMemo } from "react";
import Svg, { Path } from "react-native-svg";
import { Platform, View } from "react-native";

import type { IconProps } from "./types";
export function ChevronRight({
  size = 24,
  color,
  style,
  ...props
}: Omit<IconProps, "width" | "height" | "viewBox" | "fill">) {
  const defaultColor = useMemo(
    () => (Platform.OS === "web" ? "currentcolor" : "black"),
    []
  );
  const component = (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ? color : defaultColor}
      {...props}
    >
      <Path
        d="M7.639 21a.62.62 0 00.43-.172l8.754-8.437a.564.564 0 000-.821L8.042 3.176a.625.625 0 00-.59-.157.595.595 0 00-.432.415.565.565 0 00.164.564l8.35 7.985-8.326 8.026a.564.564 0 00-.13.633.608.608 0 00.56.358z"
        fill={color ? color : defaultColor}
      />
    </Svg>
  );

  if (style) {
    return <View style={style}>{component}</View>;
  }

  return component;
}
